if (!customElements.get('gold-skim-calculator')) {
  /* Mirrors the table: six months of saving, 30% redeeming in the 7th
     month and 20% from the 8th. */
  const MONTHS = 6;
  const BONUS_EARLY = 30;
  const BONUS_LATE = 20;

  class GoldSkimCalculator extends HTMLElement {
    constructor() {
      super();
      this.scrollContainer = null;
      this.scrollTrack = null;
      this.onScrollBound = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.scrollContainer = this.querySelector('[data-table-scroll]');
      this.scrollTrack = this.querySelector('[data-scroll-track]');
      this.qtySelect = this.querySelector('[data-qty-select]');
      this.month1Value = this.querySelector('[data-month1-value]');
      this.month1Pct = this.querySelector('[data-month1-pct]');
      this.month6Value = this.querySelector('[data-month6-value]');
      this.month6Pct = this.querySelector('[data-month6-pct]');
      this.planData = JSON.parse(this.dataset.plan ?? '{}');

      if (this.scrollContainer && this.scrollTrack) {
        this.scrollContainer.addEventListener('scroll', this.onScrollBound, { passive: true });
        this.updateScrollTrack();
      }

      if (this.qtySelect) {
        this.qtySelect.addEventListener('change', this.onQtyChange.bind(this));
      }

      this.submitBtn = this.querySelector('[data-scroll-to-contact]');
      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', this.onSubmitClick.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener('scroll', this.onScrollBound);
      }
    }

    onScroll() {
      this.updateScrollTrack();
    }

    updateScrollTrack() {
      if (!this.scrollContainer || !this.scrollTrack) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
      const maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 0) {
        this.scrollTrack.style.transform = 'translateX(0)';
        return;
      }

      const ratio = scrollLeft / maxScroll;
      const trackParentWidth = this.scrollTrack.parentElement.clientWidth;
      const trackWidth = this.scrollTrack.clientWidth;
      const maxTranslate = trackParentWidth - trackWidth;

      this.scrollTrack.style.transform = `translateX(${ratio * maxTranslate}px)`;
    }

    /*
     * Both cards show the gold held after the six months, the first redeemed
     * in the 7th month at 30% and the second from the 8th at 20%. The first
     * previously showed the monthly amount and the second a total carried
     * over from the old 25% scheme, so neither matched its own badge or the
     * table. The 30% figures here are the table's "Total Gms after" row.
     */
    onQtyChange() {
      const qty = Number(this.qtySelect.value);
      if (!this.planData[this.qtySelect.value]) return;

      const saved = qty * MONTHS;

      this.setBenefit(this.month1Value, this.month1Pct, saved, BONUS_EARLY);
      this.setBenefit(this.month6Value, this.month6Pct, saved, BONUS_LATE);
    }

    setBenefit(valueEl, pctEl, saved, bonus) {
      const total = saved * (1 + bonus / 100);

      if (valueEl) {
        /* Number() drops the float noise, so 39.000000000000004 reads 39. */
        const grams = Number(total.toFixed(2));
        valueEl.textContent = `${grams} ${grams === 1 ? 'Gram' : 'Grams'}`;
      }

      if (pctEl) {
        pctEl.textContent = `${100 + bonus}%`;
      }
    }

    onSubmitClick(event) {
      event.preventDefault();

      const contactForm = document.querySelector('emi-contact-form');
      if (!contactForm) return;

      contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' });

      const enquirySelect = contactForm.querySelector('#EmiContact-enquiry');
      if (!enquirySelect) return;

      for (const option of enquirySelect.options) {
        if (option.value === 'Gold Skim Plan Enquiry') {
          enquirySelect.value = option.value;
          break;
        }
      }
    }
  }

  customElements.define('gold-skim-calculator', GoldSkimCalculator);
}
